// Internal modules
import { appStore } from '@/store';
import { apolloMutation } from '@/lib/apollo';
import { features, getToken, logger, redirectToGenericError } from '@/lib';
import { UPDATE_PROFILE_SHIPPING_OPTIONS_MUTATION } from '../mutations';

/**
 * @function clearShippingAndTaxes
 * @description Clears the shipping and taxes set on the cart
 */
const clearShippingAndTaxes = () => {
  const hideShipping = features.isActive('hideShipping');
  const { api: apiState } = appStore.getState();
  const { profileOverrideAllowed } = apiState;

  const mutation = UPDATE_PROFILE_SHIPPING_OPTIONS_MUTATION;
  const variables = {
    hideShipping,
    profileOverrideAllowed,
    profileShippingMethods: [
      {
        default: true,
        label: 'DEFAULT',
        selected: true,
        shippingAmount: { currencyCode: 'USD', currencyValue: '0.00' },
        shippingMethodType: 'DEFAULT',
        taxAmount: { currencyCode: 'USD', currencyValue: '0.00' },
      },
    ],
    token: getToken(),
  };

  return apolloMutation({
    mutation: mutation,
    variables,
  })
    .then(({ data }) => {
      const { api: apiState } = appStore.getState();
      const { cartDetails } = apiState;
      const { api: apiActions } = appStore.getActions();
      const { setCartData } = apiActions;
      const { amounts } = data.updateProfileShippingOptions.cart;

      setCartData({
        cartAmount: amounts.total,
        cartDetails: {
          // Need to spread old values or else everything else in cartDetails
          // would be overwritten
          ...cartDetails,
          amounts,
        },
      });
      return data;
    })
    .catch(error => {
      logger.error('clear_snt_patch_cart_error', { error });
      redirectToGenericError();
    });
};

export { clearShippingAndTaxes };
